// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"a","heading":"b","screenReadersOnly":"c"};